import { render, staticRenderFns } from "./PostOrder.vue?vue&type=template&id=1937de6b&scoped=true&"
import script from "./PostOrder.vue?vue&type=script&lang=js&"
export * from "./PostOrder.vue?vue&type=script&lang=js&"
import style0 from "./PostOrder.vue?vue&type=style&index=0&id=1937de6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1937de6b",
  null
  
)

export default component.exports